import React from "react";

const HpaStoreContext = React.createContext();

export default HpaStoreContext;